import {createMultiPathSVG, createStrokeSVG} from './TEMPLATE'

// tabler: list (fill weight)
export const BulletList_Filled_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M21 6a1 1 0 0 1 -1 1h-10a1 1 0 1 1 0 -2h10a1 1 0 0 1 1 1',
    'M21 12a1 1 0 0 1 -1 1h-10a1 1 0 0 1 0 -2h10a1 1 0 0 1 1 1',
    'M21 18a1 1 0 0 1 -1 1h-10a1 1 0 0 1 0 -2h10a1 1 0 0 1 1 1',
    'M7 5.995v.02c0 1.099 -.895 1.99 -2 1.99s-2 -.891 -2 -1.99v-.02c0 -1.099 .895 -1.99 2 -1.99s2 .891 2 1.99',
    'M7 11.995v.02c0 1.099 -.895 1.99 -2 1.99s-2 -.891 -2 -1.99v-.02c0 -1.099 .895 -1.99 2 -1.99s2 .891 2 1.99',
    'M7 17.995v.02c0 1.099 -.895 1.99 -2 1.99s-2 -.891 -2 -1.99v-.02c0 -1.099 .895 -1.99 2 -1.99s2 .891 2 1.99',
  ],
  viewBox: '0 0 24 24',
})

// tabler: list
export const BulletList_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M9 6l11 0',
    'M9 12l11 0',
    'M9 18l11 0',
    'M5 6l0 .01',
    'M5 12l0 .01',
    'M5 18l0 .01',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: list
export const BulletList_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M9 6l11 0',
    'M9 12l11 0',
    'M9 18l11 0',
    'M5 6l0 .01',
    'M5 12l0 .01',
    'M5 18l0 .01',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
